import BaseApi from "./_base-api";

/**
 * Product Items API
 *
 * @class Api
 * @extends {BaseApi}
 */
class Api extends BaseApi {}

const api = new Api({
	type: "Product Item",
	path: {
		getAll: (app, _params) => {
			const params = _params || {};
			const productId = params.productId || params.product_id || params.id;
			if (productId) {
				return `products/${productId}/items`;
			} else {
				return `products/items`;
			}
		},
		getOne: (app, _params) => {
			const params = _params || {};
			const productId = params.productId || params.product_id;
			return `products/${productId}/items`;
		},
		save: (app, _params) => {
			const params = _params || {};
			const productId = params.productId || params.product_id;
			return `products/${productId}/items`;
		},
		delete: (app, _params) => {
			const params = _params || {};
			const productId = params.productId || params.product_id;
			return `products/${productId}/items`;
		},
		default: "products/items",
	},
});

export default api;
